module.exports = __webpack_public_path__ + "static/img/data5-list1.86b7d33a.png";